var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(!_setup.props.loading)?_vm._t("default"):_c('v-skeleton-loader',_vm._b({staticClass:"loader"},'v-skeleton-loader',_vm.$attrs,false))],2)
}
var staticRenderFns = []

export { render, staticRenderFns }